import $ from "jquery";
import "../components/InfoSection";
import Swiper from "swiper";
import { Navigation } from "swiper/modules";
import "swiper/scss";

$(".slider-text-section .wrapper-slider .swiper").each(function () {
  const swiperEl = this;

  const sliderCurrent = new Swiper(swiperEl, {
    modules: [Navigation],
    navigation: {
      prevEl: swiperEl.querySelector(".prev"),
      nextEl: swiperEl.querySelector(".next"),
    },
  });
});

$(".spa .swiper").each(function () {
  const swiperEl = this;

  const sliderCurrent = new Swiper(swiperEl, {
    modules: [Navigation],
    navigation: {
      prevEl: swiperEl.querySelector(".prev"),
      nextEl: swiperEl.querySelector(".next"),
    },
  });
});

const applyReadMore = () => {
  $(".js-readmore-container").each(function () {
    const $container = $(this);
    const $paragraphs = $container.find("p");
    const $toggle = $container.find(".js-readmore-toggle");

    // Skip if already applied
    if ($container.data("readmore-applied")) return;

    // Dynamic character limit based on screen width
    let charLimit = 663;
    if (window.innerWidth < 1440) {
      charLimit = 480;
    }

    let visibleChars = 0;
    const $hiddenWrapper = $('<div class="js-readmore-extra" style="display: none;"></div>');

    $paragraphs.each(function () {
      const $p = $(this);
      const textLength = $p.text().length;

      if (visibleChars + textLength <= charLimit) {
        visibleChars += textLength;
      } else {
        $hiddenWrapper.append($p);
      }
    });

    if ($hiddenWrapper.children().length > 0) {
      $container.append($hiddenWrapper);
      $container.append($toggle);
      $container.addClass("is-truncated");
      $toggle.text("Read more").removeClass("hidden");
      $container.data("readmore-applied", true); // Prevent double init

      $toggle.on("click", function (e) {
        e.preventDefault();
        const isVisible = $hiddenWrapper.is(":visible");

        $hiddenWrapper.slideToggle();
        $toggle.text(isVisible ? "Read more" : "Read less");
      });
    }
  });
};

const removeReadMore = () => {
  $(".js-readmore-container").each(function () {
    const $container = $(this);

    if (!$container.data("readmore-applied")) return;

    const $extra = $container.find(".js-readmore-extra");
    const $toggle = $container.find(".js-readmore-toggle");

    // Move hidden paragraphs back
    $extra.children().insertBefore($toggle);
    $extra.remove();
    $toggle.addClass("hidden").off("click").text("Read more");
    $container.removeClass("is-truncated").removeData("readmore-applied");
  });
};

// Set up media query listener
const mediaQuery = window.matchMedia("(min-width: 768px)");
const width1440Query = window.matchMedia("(min-width: 1440px)");
const handleResize = (e) => {
  if (e.matches) {
    applyReadMore();
  } else {
    removeReadMore();
  }
};

// Initial check
if (mediaQuery.matches) {
  applyReadMore();
} else {
  removeReadMore();
}
const reapplyReadMore = () => {
  // Only run if screen is large enough for read more
  if (mediaQuery.matches) {
    removeReadMore();
    applyReadMore();
  }
};

mediaQuery.addEventListener("change", handleResize);
width1440Query.addEventListener("change", reapplyReadMore);
